import { apiGet } from '@/lib/api';
import { pricebookKeys } from '@/lib/queryKeys';
import { useApiQuery } from '../useApiQuery';
import { usePricebookApi } from './usePricebookApi';
import { mapOperationsLineItem } from './usePricebookItems';
import type { PricebookItem } from '@/types/pricebook';

export function usePricebookItem(id: string) {
  const { client, ep } = usePricebookApi();

  return useApiQuery<PricebookItem>({
    queryKey: pricebookKeys.detail(id),
    queryFn: async () => {
      const raw = await apiGet<Record<string, unknown>>(client, ep.detail(id));
      return mapOperationsLineItem(raw);
    },
    enabled: Boolean(id),
  });
}
